import { lazy } from 'react';
import { createRoute } from '@tanstack/react-router';
import { Route as rootRoute } from './__root';

const InvalidAccess = lazy(() => import('../views/default/InvalidAccess'));

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: '/invalid-access',
  component: InvalidAccess,
});
